import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CurrencyMaskModule } from 'ngx-currency-mask';
import { RatePackageComponent } from './rate-package.component';
import { MyPackageComponent } from './my-package/my-package.component';
import { RatePackageService } from './rate-package.service'
import { SharedModule } from '../../shared/shared.module';
import { RouterModule } from '@angular/router';
import { MatCardModule } from '@angular/material/card';
import { MatTableModule } from '@angular/material/table';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { ExtractPackageComponent } from './extract-package/extract-package.component';
import { MonthFilterPackageComponent } from './month-filter/month-filter-package.component';
import { SlickModule } from 'ngx-slick';
import { OthersPackagesComponent } from './others-packages/others-packages.component';
import { PackageConfirmationComponent } from './package-confirmation/package-confirmation.component';
import { PackageResultComponent } from './package-result/package-result.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { OthersPackagesModalComponent } from './others-packages/others-packages-modal/others-packages-modal.component';


@NgModule({
imports: [
		CommonModule,
		CurrencyMaskModule,
		SharedModule,
		RouterModule,
		MatCardModule,
		MatTableModule,
		MatCheckboxModule,
		FormsModule,
		ReactiveFormsModule,
		SlickModule.forRoot(),
],
declarations: [
		RatePackageComponent,
		MyPackageComponent,
		ExtractPackageComponent,
		MonthFilterPackageComponent,
		OthersPackagesComponent,
		PackageConfirmationComponent,
		PackageResultComponent,
		OthersPackagesModalComponent
],
providers: [RatePackageService],
entryComponents: [OthersPackagesModalComponent],
})
export class RatePackageModule { }



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/rate-package/rate-package.module.ts